import { HTTP_ERROR, TIMEOUT } from '../constants';
export var post = function (url, data) {
    return new Promise(function (resolve, reject) {
        var xhr;
        try {
            // @ts-ignore
            xhr = new XDomainRequest();
        }
        catch (e) {
            xhr = new XMLHttpRequest();
        }
        xhr.withCredentials = true;
        xhr.open('POST', url, true);
        if (xhr.setRequestHeader) {
            xhr.setRequestHeader('Content-Type', 'application/json');
        }
        xhr.timeout = TIMEOUT;
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                xhr.status && xhr.status > 199 && xhr.status < 300 ? resolve('') : reject(HTTP_ERROR.STATUS_ERROR);
            }
        };
        xhr.onload = function () {
            resolve('');
        };
        xhr.ontimeout = function () {
            reject(HTTP_ERROR.TIMEOUT);
        };
        xhr.onabort = function () {
            reject(HTTP_ERROR.ABORT);
        };
        xhr.onerror = function () {
            reject(HTTP_ERROR.ERROR);
        };
        xhr.send(JSON.stringify(data));
    });
};
